import React from 'react';
import AdminNoticeForm from '../components/admin/notice/AdminNoticeForm';

const AdminNoticeFormPage = () => {
    return (
        <AdminNoticeForm />
    );
};

export default AdminNoticeFormPage;